export const mock = {
  literals: {
    title: "Detalle del viaje",
    subTitle: "Detalle de la ruta",
    button: "Seleccionar ruta por",
    choice: ["Resumen y pago", "Ida", "Vuelta"],
  },
  detailLiterals: {
    eachTime: "Cada",
    // action: "En la estación, coge el tren", // ¿Dinámico desde el servicio?
    delete: "Eliminar de la planificación",
    walkTransbordo: "Tienes que andar {time} para hacer transbordo",
    walkDestination: "Camina {time} hacia {destination}",
    drivingLicense: "Necesitas el carnet de conducir",

    /* UI-ROUTE-START-END LITERALS */
    leaveFrom: "Salimos desde",
    arrivedAt: "Llegamos a",
    /* FIN  UI-ROUTE-START-END LITERALS */

    /* UI-STOPS LITERALS*/
    seeRoute: "Ver recorrido.",
    step: "parada.",
    steps: "paradas.",
    direct: "Trayecto directo.",
    durationEstimated: "Duración estimada.",
    altFoldIcon: "Plegar.",
    altUnfoldIcon: "Desplegar.",
    actionStart: "Subete en la parada",
    actionEnd: "Bajate en la parada",
    /* FIN UI-STOPS LITERALS */
  },
  detailData: [
    {
      idPst: "0",
      arrivalTime: "22:15",
      departureTime: "22:05",
      direction: "Madrid-Chamartín-Clara Campoamor",
      icon: "cercanias",
      transport: true,
      stops: ["Madrid-Sol", "Madrid-Chamartín-Clara Campoamor"],
      line: {
        text: "1",
        color: "red",
      },
      pricetag: {
        type: "info", // "button", "info", "warn"
        text: "Aprox. 1,50€",
      },
    },
    {
      idPst: "1",
      arrivalTime: "22:35",
      departureTime: "22:19",
      direction: "Madrid-Aeropuerto T4",
      icon: "cercanias",
      transport: true,
      stops: ["Madrid-Chamartín-Clara Campoamor", "Madrid-Aeropuerto T4"],
      line: {
        text: "1",
        color: "red",
      },
      pricetag: {
        type: "button", // "button", "info", "warn"
        text: "1,50€",
      },
      buttonsFooter: [
        {
          type: "button",
          styleButton: "outline",
          id: "watchTrip",
          text: "Ver billete",
          class: "col-auto",
        },
        {
          type: "button",
          styleButton: "link",
          id: "cancelTrip",
          text: "Cancelar trayecto",
          class: "col-auto",
        },
      ],
      classContentButtonsFooter: "justify-content-between",
    },
  ],
};

export const response = {
  data: {
    pageable: {
      offset: 6,
      totalElements: 16,
      totalPages: 1,
      pageLimit: 3,
      pageSize: 3,
      pageNumber: 3,
      first: false,
      last: false,
      sort: {
        direction: "ASC",
        property: "DATETIME",
      },
    },
    bookingCounts: {
      totalPast: 19,
      totalToday: 1,
      totalFuture: 16,
      pagedPast: 0,
      pagedToday: 0,
      pagedFuture: 3,
    },
    bookings: [
      {
        id: 4394,
        plannification: true,
        chronology: "FUTURE",
        createdDate: "2025-03-30T20:46:32.739673+02:00",
        travellers: [
          {
            type: "ADULT",
          },
        ],
        outwardJourney: {
          trip: {
            Eco: {
              co2: 6.39453,
              dist: 29742,
              type: "IMT",
              rating: 0,
            },
            Origin: {
              Notes: {
                Note: [
                  {
                    value: "not accessible by wheelchair",
                    key: "WN",
                    type: "A",
                    priority: 0,
                    txtN: "not accessible by wheelchair",
                  },
                ],
              },
              mcpData: [
                {
                  name: "provider",
                  value: "taxi",
                },
                {
                  name: "providerName",
                  value: "Taxi",
                },
                {
                  name: "availability",
                  value: "A",
                },
                {
                  name: "mcpId",
                  value: "taxi:transient",
                },
                {
                  name: "externalId",
                  value: "transient",
                },
                {
                  name: "mcpType",
                  value: "V",
                },
              ],
              name: "Estación de tren Castelldefels, Castelldefels",
              type: "ST",
              id: "A=1@O=Estación de tren Castelldefels, Castelldefels@X=1978427@Y=41278556@U=80@L=100071705@",
              extId: "100071705",
              lon: 1.978427,
              lat: 41.278556,
              time: "20:43:00",
              date: "2025-04-08",
              mcp: true,
            },
            LegList: {
              Leg: [
                {
                  Origin: {
                    Notes: {
                      Note: [
                        {
                          value: "not accessible by wheelchair",
                          key: "WN",
                          type: "A",
                          priority: 0,
                          txtN: "not accessible by wheelchair",
                        },
                      ],
                    },
                    mcpData: [
                      {
                        name: "provider",
                        value: "taxi",
                      },
                      {
                        name: "providerName",
                        value: "Taxi",
                      },
                      {
                        name: "availability",
                        value: "A",
                      },
                      {
                        name: "mcpId",
                        value: "taxi:transient",
                      },
                      {
                        name: "externalId",
                        value: "transient",
                      },
                      {
                        name: "mcpType",
                        value: "V",
                      },
                    ],
                    name: "Estación de tren Castelldefels, Castelldefels",
                    type: "ST",
                    id: "A=1@O=Estación de tren Castelldefels, Castelldefels@X=1978427@Y=41278556@U=80@L=100071705@",
                    extId: "100071705",
                    lon: 1.978427,
                    lat: 41.278556,
                    time: "20:43:00",
                    date: "2025-04-08",
                    mcp: true,
                  },
                  Destination: {
                    Notes: {
                      Note: [
                        {
                          key: "P6",
                          type: "A",
                        },
                        {
                          key: "CA",
                          type: "A",
                        },
                      ],
                    },
                    name: "Barcelona, Hipercor Avinguda Meridiana",
                    type: "POI",
                    id: "A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@U=101@L=970213309@",
                    extId: "970213309",
                    lon: 2.185448,
                    lat: 41.428136,
                    time: "21:16:00",
                    date: "2025-04-08",
                  },
                  GisRef: {
                    ref: "G|1|G@T|A=1@O=Estación de tren Castelldefels, Castelldefels@L=100071705@a=128@|A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@L=970213309@a=128@|8042025|204300|211600|ft|ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§|||||",
                  },
                  Product: [
                    {
                      icon: {
                        foregroundColor: {
                          r: 255,
                          g: 255,
                          b: 255,
                          hex: "#FFFFFF",
                        },
                        backgroundColor: {
                          r: 105,
                          g: 3,
                          b: 194,
                          hex: "#6903C2",
                        },
                        res: "prod_taxi",
                      },
                      name: "Bolt",
                      internalName: "Taxi",
                    },
                  ],
                  id: "C-0:000",
                  idx: 0,
                  name: "Bolt",
                  type: "TAXI",
                  duration: "PT33M",
                  dist: 29742,
                },
              ],
            },
            checksum: "df796038_3",
            Destination: {
              Notes: {
                Note: [
                  {
                    key: "P6",
                    type: "A",
                  },
                  {
                    key: "CA",
                    type: "A",
                  },
                ],
              },
              name: "Barcelona, Hipercor Avinguda Meridiana",
              type: "POI",
              id: "A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@U=101@L=970213309@",
              extId: "970213309",
              lon: 2.185448,
              lat: 41.428136,
              time: "21:16:00",
              date: "2025-04-08",
            },
            TariffResult: {
              fareSetItem: [
                {
                  fareItem: [
                    {
                      ticket: [
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "38",
                            },
                            {
                              name: "estimateHigh",
                              value: "38",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15TmpRc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZNemd1TVN3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "standard",
                          price: 3810,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "46",
                            },
                            {
                              name: "estimateHigh",
                              value: "46",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjM3MzEsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDUuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak0zTXpFc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZORFV1T1RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "business",
                          price: 4595,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjM3MzEsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDUuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "48",
                            },
                            {
                              name: "estimateHigh",
                              value: "48",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjgsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDguMzUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15Tmpnc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZORGd1TXpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "comfort",
                          price: 4835,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjgsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDguMzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "59",
                            },
                            {
                              name: "estimateHigh",
                              value: "59",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNzAsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15TnpBc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1TVRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "premium",
                          price: 5915,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNzAsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "59",
                            },
                            {
                              name: "estimateHigh",
                              value: "59",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "6",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjksInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15Tmprc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1TVRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "xl",
                          price: 5915,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjksInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "60",
                            },
                            {
                              name: "estimateHigh",
                              value: "60",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "8",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjYwOTYsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPall3T1RZc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1T1RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "van",
                          price: 5995,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjYwOTYsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                      ],
                    },
                  ],
                  param: [
                    {
                      name: "NAME",
                      value: "Bolt Pricing",
                    },
                    {
                      name: "providerId",
                      value: "bolt",
                    },
                    {
                      name: "secId",
                      value: "C-0:000",
                    },
                    {
                      name: "secIdEnd",
                      value: "C-0:000",
                    },
                    {
                      name: "secIds",
                      value: "C-0:000",
                    },
                  ],
                  name: "Bolt Pricing",
                  fromLeg: 0,
                  toLeg: 0,
                },
              ],
              param: [
                {
                  name: "providerId",
                  value: "bolt",
                },
              ],
            },
          },
          selectedTariff: [
            {
              idLeg: 0,
              provider: "bolt",
              contextType: "BOOKEE_CONTEXT",
              price: {
                total: 1810,
                currency: "EUR",
                totalWithOutConcepts: 3810,
                concepts: [],
              },
              tickets: [
                {
                  context:
                    "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                  idBook:
                    "Ym9sdHxpZHwwLjF8OVdOelpQMm1ZV3NicXNtWEl0cHdlUT09fHsiYm9va2luZ0lkIjoxMDMyODQ2NSwiaXNBZEhvYyI6ZmFsc2UsInVzZXJJZCI6ImQ2ZTdjNjhhLTdmMDAtNGU5MC1iMTU5LWIzMTY0NGNmMDQ1MyIsImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMifQ==",
                  price: {
                    total: 3810,
                    currency: "EUR",
                    totalWithOutConcepts: 3810,
                    reservationAmount: 2172,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "SUCCESS",
                  extras: [],
                  ticketId: "fb8864d9-8208-4452-ac73-7a5fa2955876",
                  docoTicketId: "5b6261ec-5046-abc9-17e0-eef33bf5ce03",
                  offerId: "fe20cf29-9885-424a-8b60-dc417e881e27#1",
                  offerIndex: 0,
                  referenceId: "10328465",
                },
              ],
              orderId: "O-0002OB",
              status: "SUCCESS",
              notes: [],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentStatus: "SUCCESS",
                paymentDataUid: "<UNREGISTERED>",
                paymentMethod: "APPLE_PAY",
                paymentProcessId: "d6a775a8-82fb-419d-b53a-d80b0abd158e",
              },
            },
          ],
          originDate: "2025-04-08T20:43:00+02:00",
          destinationDate: "2025-04-08T21:16:00+02:00",
          completed: false,
          inProgress: false,
          price: {
            total: 3810,
            currency: "EUR",
            totalWithOutConcepts: 3810,
            concepts: [],
          },
        },
        price: {
          total: 1810,
          currency: "EUR",
          totalWithOutConcepts: 3810,
          concepts: [],
        },
      },
      {
        id: 4394,
        plannification: true,
        chronology: "FUTURE",
        createdDate: "2025-03-30T20:46:32.739673+02:00",
        travellers: [
          {
            type: "ADULT",
          },
        ],
        outwardJourney: {
          trip: {
            Eco: {
              co2: 6.39453,
              dist: 29742,
              type: "IMT",
              rating: 0,
            },
            Origin: {
              Notes: {
                Note: [
                  {
                    value: "not accessible by wheelchair",
                    key: "WN",
                    type: "A",
                    priority: 0,
                    txtN: "not accessible by wheelchair",
                  },
                ],
              },
              mcpData: [
                {
                  name: "provider",
                  value: "taxi",
                },
                {
                  name: "providerName",
                  value: "Taxi",
                },
                {
                  name: "availability",
                  value: "A",
                },
                {
                  name: "mcpId",
                  value: "taxi:transient",
                },
                {
                  name: "externalId",
                  value: "transient",
                },
                {
                  name: "mcpType",
                  value: "V",
                },
              ],
              name: "Estación de tren Castelldefels, Castelldefels",
              type: "ST",
              id: "A=1@O=Estación de tren Castelldefels, Castelldefels@X=1978427@Y=41278556@U=80@L=100071705@",
              extId: "100071705",
              lon: 1.978427,
              lat: 41.278556,
              time: "20:43:00",
              date: "2025-04-08",
              mcp: true,
            },
            LegList: {
              Leg: [
                {
                  Origin: {
                    Notes: {
                      Note: [
                        {
                          value: "not accessible by wheelchair",
                          key: "WN",
                          type: "A",
                          priority: 0,
                          txtN: "not accessible by wheelchair",
                        },
                      ],
                    },
                    mcpData: [
                      {
                        name: "provider",
                        value: "taxi",
                      },
                      {
                        name: "providerName",
                        value: "Taxi",
                      },
                      {
                        name: "availability",
                        value: "A",
                      },
                      {
                        name: "mcpId",
                        value: "taxi:transient",
                      },
                      {
                        name: "externalId",
                        value: "transient",
                      },
                      {
                        name: "mcpType",
                        value: "V",
                      },
                    ],
                    name: "Estación de tren Castelldefels, Castelldefels",
                    type: "ST",
                    id: "A=1@O=Estación de tren Castelldefels, Castelldefels@X=1978427@Y=41278556@U=80@L=100071705@",
                    extId: "100071705",
                    lon: 1.978427,
                    lat: 41.278556,
                    time: "20:43:00",
                    date: "2025-04-08",
                    mcp: true,
                  },
                  Destination: {
                    Notes: {
                      Note: [
                        {
                          key: "P6",
                          type: "A",
                        },
                        {
                          key: "CA",
                          type: "A",
                        },
                      ],
                    },
                    name: "Barcelona, Hipercor Avinguda Meridiana",
                    type: "POI",
                    id: "A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@U=101@L=970213309@",
                    extId: "970213309",
                    lon: 2.185448,
                    lat: 41.428136,
                    time: "21:16:00",
                    date: "2025-04-08",
                  },
                  GisRef: {
                    ref: "G|1|G@T|A=1@O=Estación de tren Castelldefels, Castelldefels@L=100071705@a=128@|A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@L=970213309@a=128@|8042025|204300|211600|ft|ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§|||||",
                  },
                  Product: [
                    {
                      icon: {
                        foregroundColor: {
                          r: 255,
                          g: 255,
                          b: 255,
                          hex: "#FFFFFF",
                        },
                        backgroundColor: {
                          r: 105,
                          g: 3,
                          b: 194,
                          hex: "#6903C2",
                        },
                        res: "prod_taxi",
                      },
                      name: "Bolt",
                      internalName: "Taxi",
                    },
                  ],
                  id: "C-0:000",
                  idx: 0,
                  name: "Bolt",
                  type: "TAXI",
                  duration: "PT33M",
                  dist: 29742,
                },
              ],
            },
            checksum: "df796038_3",
            Destination: {
              Notes: {
                Note: [
                  {
                    key: "P6",
                    type: "A",
                  },
                  {
                    key: "CA",
                    type: "A",
                  },
                ],
              },
              name: "Barcelona, Hipercor Avinguda Meridiana",
              type: "POI",
              id: "A=4@O=Barcelona, Hipercor Avinguda Meridiana@X=2185448@Y=41428136@U=101@L=970213309@",
              extId: "970213309",
              lon: 2.185448,
              lat: 41.428136,
              time: "21:16:00",
              date: "2025-04-08",
            },
            TariffResult: {
              fareSetItem: [
                {
                  fareItem: [
                    {
                      ticket: [
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "38",
                            },
                            {
                              name: "estimateHigh",
                              value: "38",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15TmpRc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZNemd1TVN3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "standard",
                          price: 3810,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "46",
                            },
                            {
                              name: "estimateHigh",
                              value: "46",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjM3MzEsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDUuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak0zTXpFc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZORFV1T1RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "business",
                          price: 4595,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjM3MzEsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDUuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "48",
                            },
                            {
                              name: "estimateHigh",
                              value: "48",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjgsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDguMzUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15Tmpnc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZORGd1TXpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "comfort",
                          price: 4835,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjgsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NDguMzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "59",
                            },
                            {
                              name: "estimateHigh",
                              value: "59",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "4",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNzAsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15TnpBc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1TVRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "premium",
                          price: 5915,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNzAsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "59",
                            },
                            {
                              name: "estimateHigh",
                              value: "59",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "6",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjksInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPak15Tmprc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1TVRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "xl",
                          price: 5915,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjksInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuMTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "estimateLow",
                              value: "60",
                            },
                            {
                              name: "estimateHigh",
                              value: "60",
                            },
                            {
                              name: "AVAILABLE_SEATS",
                              value: "8",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjYwOTYsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeUlpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPall3T1RZc0luQnBZMnRWY0ZScGJXVWlPaUl5TURJMUxUQTBMVEE0VkRJd09qUXpPakF3S3pBeU9qQXdJaXdpYjNKcFoybHVJanA3SW5SNWNHVWlPaUpRYjJsdWRDSXNJbU52YjNKa2FXNWhkR1Z6SWpwYk1TNDVOemcwTWpjc05ERXVNamM0TlRVMlhYMHNJbVJsYzNScGJtRjBhVzl1SWpwN0luUjVjR1VpT2lKUWIybHVkQ0lzSW1OdmIzSmthVzVoZEdWeklqcGJNaTR4T0RVME5EZ3NOREV1TkRJNE1UTTJYWDBzSW1WemRHbHRZWFJwYjI1VGIzVnlZMlVpT2lKVFEwaEZSRlZNUlVSZlJWTlVTVTFCVkVsUFRsTWlMQ0psYzNScGJXRjBaV1JRY21salpTSTZOVGt1T1RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            text: "Ver oferta",
                            contentType: "XBOOK_CTX",
                          },
                          name: "van",
                          price: 5995,
                          cur: "EUR",
                          shpCtx:
                            "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjYwOTYsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6NTkuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                      ],
                    },
                  ],
                  param: [
                    {
                      name: "NAME",
                      value: "Bolt Pricing",
                    },
                    {
                      name: "providerId",
                      value: "bolt",
                    },
                    {
                      name: "secId",
                      value: "C-0:000",
                    },
                    {
                      name: "secIdEnd",
                      value: "C-0:000",
                    },
                    {
                      name: "secIds",
                      value: "C-0:000",
                    },
                  ],
                  name: "Bolt Pricing",
                  fromLeg: 0,
                  toLeg: 0,
                },
              ],
              param: [
                {
                  name: "providerId",
                  value: "bolt",
                },
              ],
            },
          },
          selectedTariff: [
            {
              idLeg: 0,
              provider: "bolt",
              contextType: "BOOKEE_CONTEXT",
              price: {
                total: 1810,
                currency: "EUR",
                totalWithOutConcepts: 3810,
                concepts: [],
              },
              tickets: [
                {
                  context:
                    "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIyIiwidmVoaWNsZUNhdGVnb3J5SWQiOjMyNjQsInBpY2tVcFRpbWUiOiIyMDI1LTA0LTA4VDIwOjQzOjAwKzAyOjAwIiwib3JpZ2luIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMS45Nzg0MjcsNDEuMjc4NTU2XX0sImRlc3RpbmF0aW9uIjp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbMi4xODU0NDgsNDEuNDI4MTM2XX0sImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMiLCJlc3RpbWF0ZWRQcmljZSI6MzguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                  idBook:
                    "Ym9sdHxpZHwwLjF8OVdOelpQMm1ZV3NicXNtWEl0cHdlUT09fHsiYm9va2luZ0lkIjoxMDMyODQ2NSwiaXNBZEhvYyI6ZmFsc2UsInVzZXJJZCI6ImQ2ZTdjNjhhLTdmMDAtNGU5MC1iMTU5LWIzMTY0NGNmMDQ1MyIsImVzdGltYXRpb25Tb3VyY2UiOiJTQ0hFRFVMRURfRVNUSU1BVElPTlMifQ==",
                  price: {
                    total: 3810,
                    currency: "EUR",
                    totalWithOutConcepts: 3810,
                    reservationAmount: 2172,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "SUCCESS",
                  extras: [],
                  ticketId: "fb8864d9-8208-4452-ac73-7a5fa2955876",
                  docoTicketId: "5b6261ec-5046-abc9-17e0-eef33bf5ce03",
                  offerId: "fe20cf29-9885-424a-8b60-dc417e881e27#1",
                  offerIndex: 0,
                  referenceId: "10328465",
                },
              ],
              orderId: "O-0002OB",
              status: "SUCCESS",
              notes: [],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentStatus: "SUCCESS",
                paymentDataUid: "<UNREGISTERED>",
                paymentMethod: "GOOGLE_PAY",
                paymentProcessId: "d6a775a8-82fb-419d-b53a-d80b0abd158e",
              },
            },
          ],
          originDate: "2025-04-08T20:43:00+02:00",
          destinationDate: "2025-04-08T21:16:00+02:00",
          completed: false,
          inProgress: false,
          price: {
            total: 3810,
            currency: "EUR",
            totalWithOutConcepts: 3810,
            concepts: [],
          },
        },
        price: {
          total: 1810,
          currency: "EUR",
          totalWithOutConcepts: 3810,
          concepts: [],
        },
      },
      {
        id: 4370,
        plannification: true,
        chronology: "TODAY",
        createdDate: "2025-01-09T12:10:42.295435+01:00",
        travellers: [
          {
            type: "ADULT",
            personalInformation: {
              customerFullName: {
                name: "Test CIT",
                firstSurname: "MOCKS",
                secondSurname: "",
              },
            },
          },
        ],
        outwardJourney: {
          trip: {
            Destination: {
              Notes: {
                Note: [],
              },
              date: "2025-01-15",
              extId: "100092102",
              id: "A=1@O=Estación de tren Toledo, Toledo@X=-4011248@Y=39862269@U=80@L=100092102@",
              lat: 39.86227,
              lon: -4.011248,
              name: "Estación de tren Toledo, Toledo",
              time: "14:19:00",
              type: "ST",
            },
            Eco: {
              co2: 3.876585,
              rating: 3,
            },
            LegList: {
              Leg: [
                {
                  Destination: {
                    Notes: {
                      Note: [],
                    },
                    date: "2025-01-15",
                    extId: "100060000",
                    id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                    lat: 40.40644,
                    lon: -3.69089,
                    name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                    time: "13:15:00",
                    type: "ST",
                  },
                  GisRef: {
                    ref: "G|1|G@T|A=2@O=Madrid, Calle de Sámbara@X=-3647454@Y=40435520@b=980479332@a=128@|A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@|15012025|130200|131500|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                  },
                  Notes: {
                    Note: [
                      {
                        key: "",
                        type: "UNKNOWN",
                        value: "",
                      },
                    ],
                  },
                  Origin: {
                    Notes: {
                      Note: [],
                    },
                    date: "2025-01-15",
                    id: "A=2@O=Madrid, Calle de Sámbara@X=-3647454@Y=40435520@U=100@b=980479332@",
                    lat: 40.43552,
                    lon: -3.647454,
                    name: "Madrid, Calle de Sámbara",
                    time: "13:02:00",
                    type: "ADR",
                  },
                  Product: [
                    {
                      icon: {
                        backgroundColor: {
                          hex: "#6903C2",
                        },
                        foregroundColor: {
                          hex: "#FFFFFF",
                        },
                      },
                      name: "Movitaxi",
                    },
                  ],
                  id: "C-0:000",
                  idx: 0,
                  name: "movitaxi",
                  type: "TAXI",
                },
              ],
            },
            Origin: {
              Notes: {
                Note: [],
              },
              date: "2025-01-15",
              id: "A=2@O=Madrid, Calle de Sámbara@X=-3647454@Y=40435520@U=100@b=980479332@",
              lat: 40.43552,
              lon: -3.647454,
              name: "Madrid, Calle de Sámbara",
              time: "13:02:00",
              type: "ADR",
            },
            TariffResult: {
              fareSetItem: [
                {
                  fareItem: [
                    {
                      ticket: [
                        {
                          cur: "EUR",
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5qRTJOVGxsTmpBdFlqRmxZeTAwTkdVMExXSTNOelF0WW1ObU1ETmhPVEkyWldZMUlpd2ljSEpwWTJVaU9qSXhMamN6TXl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                            contentType: "XBOOK_CTX",
                            text: "Ver oferta",
                          },
                          group: {},
                          name: "Movitaxi Standard",
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "VEHICLE_TYPE",
                              value: "4",
                            },
                            {
                              name: "VEHICLE_CLASS",
                              value: "Standard",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjE2NTllNjAtYjFlYy00NGU0LWI3NzQtYmNmMDNhOTI2ZWY1IiwicHJpY2UiOjIxLjczMywiY3VycmVuY3kiOiJFVVIifQ==",
                            },
                          ],
                          price: 2173,
                          shpCtx:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjE2NTllNjAtYjFlYy00NGU0LWI3NzQtYmNmMDNhOTI2ZWY1IiwicHJpY2UiOjIxLjczMywiY3VycmVuY3kiOiJFVVIifQ==",
                        },
                        {
                          cur: "EUR",
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5XRmtZVFZtTnpVdE9URXdNeTAwWVRSbExXRmlZMlV0TnpNNVl6TmpOak5pTmpneElpd2ljSEpwWTJVaU9qTXdMamtzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                            contentType: "XBOOK_CTX",
                            text: "Ver oferta",
                          },
                          group: {},
                          name: "Movitaxi Minivan 7pax",
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "VEHICLE_TYPE",
                              value: "9",
                            },
                            {
                              name: "VEHICLE_CLASS",
                              value: "Minivan 7pax",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNWFkYTVmNzUtOTEwMy00YTRlLWFiY2UtNzM5YzNjNjNiNjgxIiwicHJpY2UiOjMwLjksImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          price: 3090,
                          shpCtx:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNWFkYTVmNzUtOTEwMy00YTRlLWFiY2UtNzM5YzNjNjNiNjgxIiwicHJpY2UiOjMwLjksImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                        {
                          cur: "EUR",
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1HVmxNRFE1WTJRdE5UazJZaTAwWVRabUxXRmhOVGd0TURnek0yTTVOREJpT1RneElpd2ljSEpwWTJVaU9qSTFMak16T0N3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                            contentType: "XBOOK_CTX",
                            text: "Ver oferta",
                          },
                          group: {},
                          name: "Movitaxi VTC Executive",
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "VEHICLE_TYPE",
                              value: "5",
                            },
                            {
                              name: "VEHICLE_CLASS",
                              value: "VTC Executive",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMGVlMDQ5Y2QtNTk2Yi00YTZmLWFhNTgtMDgzM2M5NDBiOTgxIiwicHJpY2UiOjI1LjMzOCwiY3VycmVuY3kiOiJFVVIifQ==",
                            },
                          ],
                          price: 2534,
                          shpCtx:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMGVlMDQ5Y2QtNTk2Yi00YTZmLWFhNTgtMDgzM2M5NDBiOTgxIiwicHJpY2UiOjI1LjMzOCwiY3VycmVuY3kiOiJFVVIifQ==",
                        },
                        {
                          cur: "EUR",
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5qZzFZVFV4WVdNdFltVXpOQzAwWWpFd0xUaGlNall0TW1ReU1qWTBNelZpWW1Zd0lpd2ljSEpwWTJVaU9qYzVMamswT0RZc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                            contentType: "XBOOK_CTX",
                            text: "Ver oferta",
                          },
                          group: {},
                          name: "Movitaxi Minivan EXECUTIVE 7pax",
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "VEHICLE_TYPE",
                              value: "10",
                            },
                            {
                              name: "VEHICLE_CLASS",
                              value: "Minivan EXECUTIVE 7pax",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjg1YTUxYWMtYmUzNC00YjEwLThiMjYtMmQyMjY0MzViYmYwIiwicHJpY2UiOjc5Ljk0ODYsImN1cnJlbmN5IjoiRVVSIn0=",
                            },
                          ],
                          price: 7995,
                          shpCtx:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjg1YTUxYWMtYmUzNC00YjEwLThiMjYtMmQyMjY0MzViYmYwIiwicHJpY2UiOjc5Ljk0ODYsImN1cnJlbmN5IjoiRVVSIn0=",
                        },
                      ],
                    },
                  ],
                  fromLeg: 0,
                  name: "Movitaxi Pricing",
                  param: [
                    {
                      name: "NAME",
                      value: "Movitaxi Pricing",
                    },
                    {
                      name: "secId",
                      value: "C-0:000",
                    },
                    {
                      name: "secIdEnd",
                      value: "C-0:000",
                    },
                    {
                      name: "secIds",
                      value: "C-0:000",
                    },
                  ],
                  secIds: "C-0:000",
                  toLeg: 0,
                },
              ],
            },
            checksum: "9aca89fd_3",
          },
          selectedTariff: [
            {
              idLeg: 0,
              provider: "movitaxi",
              contextType: "BOOKEE_CONTEXT",
              price: {
                total: 2173,
                currency: "EUR",
                totalWithOutConcepts: 2173,
                concepts: [],
              },
              tickets: [
                {
                  context:
                    "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjE2NTllNjAtYjFlYy00NGU0LWI3NzQtYmNmMDNhOTI2ZWY1IiwicHJpY2UiOjIxLjczMywiY3VycmVuY3kiOiJFVVIifQ==",
                  idBook:
                    "bW92aXRheGl8aWR8MC4xfERBUTIyRExnODlUV1g4cmhyWmlGMEE9PXx7InVzZXJJZCI6IjQxMjBjNDc5LWEyMDctNGYxYy04ODA3LTc5NjkzYjE5OTI3ZiIsInNlcnZpY2VJZCI6IjYxNjU5ZTYwLWIxZWMtNDRlNC1iNzc0LWJjZjAzYTkyNmVmNSJ9",
                  price: {
                    total: 2173,
                    currency: "EUR",
                    totalWithOutConcepts: 2173,
                    reservationAmount: 0,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "CONFIRMED",
                  extras: [],
                  ticketId: "ad3a8b4d-ae85-4b93-945e-8b0bf0079df8",
                  docoTicketId: "e9c6de14-2d4c-af1d-d6cb-0c17a98d56eb",
                  offerId: "72fce6c3-fa16-4d68-826c-2da8a4ec8ad0#1",
                  offerIndex: 0,
                  referenceId: "2092074",
                },
              ],
              orderId: "O-0001R8",
              status: "CONFIRMED",
              notes: [],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentStatus: "SUCCESS",
                paymentDataUid: "d477753f-6452-4729-9f4e-a4e1f2174495",
                paymentMethod: "CREDIT_CARD",
                paymentProcessId: "48eaf73a-501b-4be8-8c87-c0889ce21492",
                digits: "541008******1539",
                expiryDate: "2049-12-31",
                ccType: "VISA",
                providerInfo: {
                  id: 1980,
                  providerReference: "2728XDCCcWTs",
                  providerName: "movitaxi",
                  totalPrice: 687,
                  quantity: 1,
                  reservation: false,
                  additionalProperties:
                    "renfe+7+1980+O-0001DT+2024-10-02 06:26:54",
                  merchantId: 7,
                },
              },
            },
          ],
          originDate: "2025-01-15T13:02:00+01:00",
          destinationDate: "2025-01-15T14:19:00+01:00",
          completed: false,
          inProgress: false,
          price: {
            total: 3173,
            currency: "EUR",
            totalWithOutConcepts: 3173,
            concepts: [],
          },
        },
        price: {
          total: 3173,
          currency: "EUR",
          totalWithOutConcepts: 3173,
          concepts: [],
        },
      },
      /*{
        "id": 4009,
        "plannification": false,
        "chronology": "FUTURE",
        "createdDate": "2025-01-29T12:05:00.062882+01:00",
        "travellers": [
            {
                "type": "ADULT"
            }
        ],
        "outwardJourney": {
            "selectedTariff": [
                {
                    "idLeg": 0,
                    "provider": "tmb",
                    "contextType": "BOOKEE_CONTEXT",
                    "price": {
                        "total": 1750,
                        "currency": "EUR",
                        "totalWithOutConcepts": 1750,
                        "concepts": []
                    },
                    "tickets": [
                        {
                            "context": "tmb|offer|0.1|MQrWbBtvLf5Z/rHiLAypww==|eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ4Ym9vayIsImRhdGEiOiJ7XCJpdGVtc1wiOlt7XCJwcm9kdWN0Q29kZVwiOlwiMDQ5XCIsXCJxdWFudGl0eVwiOjEsXCJwcmljZVwiOntcImN1cnJlbmN5XCI6XCJFVVJcIixcInZhbHVlXCI6XCIxNzUwXCJ9fV0sXCJ0b3RhbFF1YW50aXR5UmVxdWVzdGVkV2l0aG91dFByb2R1Y3RcIjowLFwicmVzZXJ2YXRpb25cIjpmYWxzZX0ifQ.qopXG4moMIexN30zq7gKaFydSqHF7Yb5fMJKnPYqOWY",
                            "idBook": "dG1ifGlkfDAuMXwrNlJRWEEvTlEvKzdWY00wRkxiQitRPT18eyJlbGVjdHJvbmljQ29kZSI6IjMwNDM5OTgwNzc1NDEiLCJzZWxsU2VydmljZURhdGUiOiIyMDI1LTAxLTI5VDExOjA1OjM1LjY1MTc5OTc3NVoiLCJpdGVtcyI6W3sicHJvZHVjdENvZGUiOiIwNDkiLCJxdWFudGl0eSI6MSwicXVhbnRpdHlDb25zdW1lZCI6MCwicXVhbnRpdHlQZW5kaW5nQ29uc3VtdGlvbiI6MSwicXVhbnRpdHlQZW5kaW5nQ29uc3VtcHRpb24iOjEsInByb2R1Y3Rab25lTnVtYmVyIjowLCJ0aWNrZXRDb2RlIjoiNDkiLCJwaHlzaWNhbFRpY2tldFN1cHBvcnRDb2RlcyI6WyI4IiwiMSIsIjUiXSwiZmFicmljYXRpb25UaWNrZXREZXZpY2VDb2RlcyI6WyJBIiwiTSIsIkQiLCJJIl0sInByb2R1Y3REZXNjcmlwdGlvbiI6IkFxdWVzdCBhYm9uYW1lbnQgZGUgNDggaG9yZXMgZGVzIGRlIGxhIHByaW1lcmEgdmFsaWRhY2nDsyBpbmNsb3UgdmlhdGdlcyBpbMK3bGltaXRhdHMgYW1iIGVsIHRyYW5zcG9ydCBww7pibGljIGRlIEJhcmNlbG9uYS4ifV0sInJlc2VydmF0aW9uTmVlZGVkIjpmYWxzZX0=",
                            "price": {
                                "total": 1750,
                                "currency": "EUR",
                                "totalWithOutConcepts": 1750,
                                "reservationAmount": 0,
                                "estimatedPrice": 0,
                                "concepts": []
                            },
                            "status": "BOOKED",
                            "extras": [],
                            "ticketId": "27157c5b-700e-4868-b76e-5ed8a361c4c9",
                            "docoTicketId": "bacc1ef4-249d-c450-47ea-c3dc9ec8c787",
                            "offerId": "71991f3b-c2cc-4d8e-8bc6-6cf1278fe58a#1",
                            "offerIndex": 0,
                            "invoiceDownloadUrl": "https://renfe.hafas.cloud/content/v1/c/renfe/simplified-invoice?v=$5$2by9rdbVm8cSedc$pwwsJBJi4LKGMwu9JrhhPaqqxd3fEsZu3AXCkT0D5F6&c=$5$g9PboRueem7qWdr$zc/4yerLRI4RJUlfAH7xtZtWNMFpaYt4/Gad3i6kOP.&invoiceNumber=R0022501290098400116000000000001&provider=tmb"
                        }
                    ],
                    "orderId": "O-0002DO",
                    "status": "BOOKED",
                    "notes": [],
                    paymentInfo: {
                      paymentProvider: "REDSYS",
                      paymentStatus: "SUCCESS",
                      paymentDataUid: "d477753f-6452-4729-9f4e-a4e1f2174495",
                      paymentMethod: "CREDIT_CARD",
                      paymentProcessId: "48eaf73a-501b-4be8-8c87-c0889ce21492",
                      digits: "541008******1539",
                      expiryDate: "2049-12-31",
                      ccType: "VISA",
                      providerInfo: {
                        id: 1980,
                        providerReference: "2728XDCCcWTs",
                        providerName: "movitaxi",
                        totalPrice: 687,
                        quantity: 1,
                        reservation: false,
                        additionalProperties:
                          "renfe+7+1980+O-0001DT+2024-10-02 06:26:54",
                        merchantId: 7,
                      },
                    },
                }
            ],
            "originDate": "2025-01-29T12:05:35+01:00",
            "destinationDate": "2025-04-29T12:05:35+02:00",
            "completed": false,
            "inProgress": false,
            "price": {
                "total": 1750,
                "currency": "EUR",
                "totalWithOutConcepts": 1750,
                "concepts": []
            },
            "activity": {
                "name": "Hola Barcelona Travel Card 48H",
                "catalogueId": "holabarcelona-travel-card",
                "catalogueItemId": "holabarcelona-travel-card-2D",
                "details": {
                    "details": [
                        {
                            "title": "Descripción",
                            "body": "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte público de Barcelona durante 2 días (48 h) consecutivos desde la primera validación y a cualquier hora del día."
                        },
                        {
                            "title": "Incluye",
                            "body": "La tarjeta Hola Barcelona Travel Card és un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Rodalies de Catalunya (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagues suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto."
                        },
                        {
                            "title": "Cómo funciona",
                            "body": "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Únicamente Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas"
                        },
                        {
                            "title": "Política de cancelación",
                            "body": "Reserva válida durante 90 días naturales desde la fecha de la compra y, como máximo, hasta el último día de febrero del año siguiente."
                        }
                    ],
                    "url": "https://www.docomobility.com/sites/default/files/2024-04/Travel%20card.png"
                },
                "parameters": [
                    {
                        "key": "totalQuantityRequestedWithoutPkroduct",
                        "name": "Total additional seats required without product",
                        "type": "NUMBER"
                    },
                    {
                        "key": "additionalProducts",
                        "name": "Additional products",
                        "description": "Additional products encoded as bookee context",
                        "type": "ENUM_LIST"
                    },
                    {
                        "key": "serviceDate",
                        "name": "Service date",
                        "type": "DATETIME"
                    }
                ],
                "numberOfVouchers": 1,
                "voucher": {
                    "emitterCode": "439",
                    "voucherType": "VOUCHER_MULTIPRODUCTE",
                    "voucherItems": [
                        {
                            "quantity": 1,
                            "ticketCode": "49",
                            "productCode": "049",
                            "productName": "HOLA BCN 2 DIES (48 H)",
                            "quantityConsumed": 0,
                            "productZoneNumber": 0,
                            "productDescription": "HOLA BCN 2 DIES (48 H)",
                            "quantityPendingConsumtion": 1,
                            "physicalTicketSupportCodes": [
                                "8",
                                "1",
                                "5"
                            ],
                            "quantityPendingConsumption": 1,
                            "fabricationTicketDeviceCodes": [
                                "A",
                                "M",
                                "D",
                                "I"
                            ]
                        }
                    ],
                    "voucherStatus": "ANULLAT",
                    "electronicCode": "3043998077541",
                    "emitterDescription": "Renfe - DoCo",
                    "validityEndDatetime": "2025-04-29T10:05:35Z",
                    "validityStartDatetime": "2025-01-29T11:05:35Z",
                    "voucherSequenceNumber": 1
                }
            }
        },
        "price": {
            "total": 1750,
            "currency": "EUR",
            "totalWithOutConcepts": 1750,
            "concepts": []
        }
      },*/
      {
        id: 26639,
        plannification: true,
        chronology: "FUTURE",
        createdDate: "2025-02-20T16:10:00.3811+01:00",
        travellers: [
          {
            type: "ADULT",
          },
        ],
        outwardJourney: {
          selectedTariff: [
            {
              idLeg: 0,
              provider: "globick",
              contextType: "CUSTOM_CONTEXT",
              price: {
                total: 925,
                currency: "EUR",
                totalWithOutConcepts: 925,
                concepts: [],
              },
              tickets: [
                {
                  context: "GLOBICK_CONTEXT",
                  idBook: "48325",
                  price: {
                    total: 925,
                    currency: "EUR",
                    totalWithOutConcepts: 925,
                    reservationAmount: 0,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "BOOKED",
                  extras: [],
                  ticketId: "48325",
                  docoTicketId: "6748ee3e-4fa6-63ee-6062-8b3744fc8488",
                  offerId: "GOJALZTIUH",
                  offerIndex: 0,
                },
              ],
              orderId: "48325",
              status: "BOOKED",
              notes: [],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentStatus: "SUCCESS",
                paymentDataUid: "d477753f-6452-4729-9f4e-a4e1f2174495",
                paymentMethod: "CREDIT_CARD",
                paymentProcessId: "48eaf73a-501b-4be8-8c87-c0889ce21492",
                digits: "541008******1539",
                expiryDate: "2049-12-31",
                ccType: "VISA",
                providerInfo: {
                  id: 1980,
                  providerReference: "2728XDCCcWTs",
                  providerName: "movitaxi",
                  totalPrice: 687,
                  quantity: 1,
                  reservation: false,
                  additionalProperties:
                    "renfe+7+1980+O-0001DT+2024-10-02 06:26:54",
                  merchantId: 7,
                },
              },
            },
          ],
          originDate: "2025-02-22T00:00:00+01:00",
          destinationDate: "2025-02-23T00:00:00+01:00",
          completed: true,
          inProgress: false,
          price: {
            total: 925,
            currency: "EUR",
            totalWithOutConcepts: 925,
            concepts: [],
          },
          experience: {
            activityId: "98",
            activitySessionId: 13275953,
            totalQuantity: 1,
            imageUrl:
              "https://cf-simple-s3-origin-cloudfront-s3-oneticket-pre-177734401659.s3-eu-west-1.amazonaws.com/images/activities/65/2818/thumbnails/ed2abe0e1fd746768de5efb36e6014f7.jpg",
            name: "La Pedrera Esencial: Sin colas + Audioguía",
            location: "Barcelona",
            activityDate: "2025-02-22T00:00:00Z",
            description:
              "Con un fachada llena de fluidez y extravagantes chimeneas en el techo, la Casa Milà, también conocida como _La Pedrera_, representa el trabajo de Gaudí en su máximo esplendor. El interior ornamentado también es obra del gran arquitecto catalán. Evita las colas y accede directamente a esta obra maestra modernista.",
            include: "null",
            importantInfo:
              "No se recomienda acceder a la visita con mochilas.\r\n\r\nAcceso gratuito para menores de 6 años.\r\n\r\n",
            cancellationPolicy:
              "Recibe una devolución del 100% si cancela antes de  0 horas.",
            clientSession:
              "NnwyMzQ5MzA1fDF8Q0lUXzE2MDAwOHwyMDI1LTAyLTIwIDE1OjA5OjEzLjQ3MTM4OA==",
          },
        },
        price: {
          total: 925,
          currency: "EUR",
          totalWithOutConcepts: 925,
          concepts: [],
        },
      },
    ],
  },

  status: 200,
};

export const responseMoviTaxiBolt = {
  data: {
    pageable: {
      offset: 0,
      totalElements: 7,
      totalPages: 1,
      pageLimit: 15,
      pageSize: 7,
      pageNumber: 1,
      first: true,
      last: true,
      sort: {
        direction: "ASC",
        property: "DATETIME",
      },
    },
    bookingCounts: {
      totalPast: 4,
      totalToday: 5,
      totalFuture: 2,
      pagedPast: 0,
      pagedToday: 5,
      pagedFuture: 2,
    },
    bookings: [
      {
        id: 28504,
        plannification: true,
        chronology: "TODAY",
        createdDate: "2026-03-06T08:11:26.833755+01:00",
        travellers: [
          {
            type: "ADULT",
          },
        ],
        outwardJourney: {
          trip: {
            Destination: {
              Notes: {
                Note: [
                  {
                    key: "WN",
                    type: "UNKNOWN",
                    value: "Not accessible by wheelchair",
                  },
                ],
              },
              date: "2026-03-06",
              extId: "100003194",
              id: "A=1@O=Les Corts, Barcelona@X=2130875@Y=41384116@U=80@L=100003194@",
              lat: 41.384117,
              lon: 2.130875,
              name: "Les Corts, Barcelona",
              time: "10:13:00",
              type: "ST",
            },
            Eco: {
              co2: 0.373885,
              rating: 0,
            },
            LegList: {
              Leg: [
                {
                  Destination: {
                    Notes: {
                      Note: [
                        {
                          key: "WN",
                          type: "UNKNOWN",
                          value: "Not accessible by wheelchair",
                        },
                      ],
                    },
                    date: "2026-03-06",
                    extId: "100003194",
                    id: "A=1@O=Les Corts, Barcelona@X=2130875@Y=41384116@U=80@L=100003194@",
                    lat: 41.384117,
                    lon: 2.130875,
                    name: "Les Corts, Barcelona",
                    time: "10:13:00",
                    type: "ST",
                  },
                  GisRef: {
                    ref: "G|1|G@T|A=1@O=Sants Estació, Barcelona@L=400003196@a=128@|A=1@O=Les Corts, Barcelona@L=100003194@a=128@|6032026|100900|101300|ft|ff@$f@$f@$f@$t@2000@50000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bf@$f@$f@$f@$t@2000@50000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§|||||",
                  },
                  Notes: {
                    Note: [
                      {
                        key: "",
                        type: "UNKNOWN",
                        value: "",
                      },
                    ],
                  },
                  Origin: {
                    Notes: {
                      Note: [],
                    },
                    date: "2026-03-06",
                    extId: "400003196",
                    id: "A=1@O=Sants Estació, Barcelona@X=2140988@Y=41381599@U=80@L=400003196@",
                    lat: 41.3816,
                    lon: 2.140988,
                    name: "Sants Estació, Barcelona",
                    time: "10:09:00",
                    type: "ST",
                  },
                  Product: [
                    {
                      icon: {
                        backgroundColor: {
                          hex: "#6903C2",
                        },
                        foregroundColor: {
                          hex: "#FFFFFF",
                        },
                      },
                      name: "Movitaxi",
                    },
                  ],
                  id: "C-0:000",
                  idx: 0,
                  name: "movitaxi",
                  type: "TAXI",
                },
                 {
                  Destination: {
                    Notes: {
                      Note: [
                        {
                          key: "WN",
                          type: "UNKNOWN",
                          value: "Not accessible by wheelchair",
                        },
                      ],
                    },
                    date: "2026-03-06",
                    extId: "100003194",
                    id: "A=1@O=Les Corts, Barcelona@X=2130875@Y=41384116@U=80@L=100003194@",
                    lat: 41.384117,
                    lon: 2.130875,
                    name: "Les Corts, Barcelona",
                    time: "10:13:00",
                    type: "ST",
                  },
                  GisRef: {
                    ref: "G|1|G@T|A=1@O=Sants Estació, Barcelona@L=400003196@a=128@|A=1@O=Les Corts, Barcelona@L=100003194@a=128@|6032026|100900|101300|ft|ff@$f@$f@$f@$t@2000@50000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bf@$f@$f@$f@$t@2000@50000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§|||||",
                  },
                  Notes: {
                    Note: [
                      {
                        key: "",
                        type: "UNKNOWN",
                        value: "",
                      },
                    ],
                  },
                  Origin: {
                    Notes: {
                      Note: [],
                    },
                    date: "2026-03-06",
                    extId: "400003196",
                    id: "A=1@O=Sants Estació, Barcelona@X=2140988@Y=41381599@U=80@L=400003196@",
                    lat: 41.3816,
                    lon: 2.140988,
                    name: "Sants Estació, Barcelona",
                    time: "10:09:00",
                    type: "ST",
                  },
                  Product: [
                    {
                      icon: {
                        backgroundColor: {
                          hex: "#6903C2",
                        },
                        foregroundColor: {
                          hex: "#FFFFFF",
                        },
                      },
                      name: "Movitaxi",
                    },
                  ],
                  id: "C-0:000",
                  idx: 1,
                  name: "movitaxi",
                  type: "TAXI",
                },

              ],
            },
            Origin: {
              Notes: {
                Note: [],
              },
              date: "2026-03-06",
              extId: "400003196",
              id: "A=1@O=Sants Estació, Barcelona@X=2140988@Y=41381599@U=80@L=400003196@",
              lat: 41.3816,
              lon: 2.140988,
              name: "Sants Estació, Barcelona",
              time: "10:09:00",
              type: "ST",
            },
            TariffResult: {
              fareSetItem: [
                {
                  fareItem: [
                    {
                      ticket: [
                        {
                          cur: "EUR",
                          externalContent: {
                            content:
                              "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlOQ0lzSW1KMVpHZGxkRWxrSWpvaVpqRTVOalZpT1RZdE9UQXdOeTAwWmpjNUxXRXhORGN0WWpVM01XTmhOVGxoTldRNElpd2ljSEpwWTJVaU9qRXlMakl5TmpBNU9UazVPVGs1T1RrNU9Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                            contentType: "XBOOK_CTX",
                            text: "Ver oferta",
                          },
                          group: {},
                          name: "Movitaxi Standard",
                          param: [
                            {
                              name: "STATUS",
                              value: "AVAILABLE",
                            },
                            {
                              name: "VEHICLE_TYPE",
                              value: "4",
                            },
                            {
                              name: "VEHICLE_CLASS",
                              value: "Standard",
                            },
                            {
                              name: "BOOKING_CONTEXT",
                              value:
                                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yNCIsImJ1ZGdldElkIjoiZjE5NjViOTYtOTAwNy00Zjc5LWExNDctYjU3MWNhNTlhNWQ4IiwicHJpY2UiOjEyLjIyNjA5OTk5OTk5OTk5OSwiY3VycmVuY3kiOiJFVVIifQ==",
                            },
                          ],
                          price: 1223,
                          shpCtx:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yNCIsImJ1ZGdldElkIjoiZjE5NjViOTYtOTAwNy00Zjc5LWExNDctYjU3MWNhNTlhNWQ4IiwicHJpY2UiOjEyLjIyNjA5OTk5OTk5OTk5OSwiY3VycmVuY3kiOiJFVVIifQ==",
                        },
                      ],
                    },
                  ],
                  name: "Movitaxi Pricing",
                  param: [
                    {
                      name: "NAME",
                      value: "Movitaxi Pricing",
                    },
                    {
                      name: "secId",
                      value: "C-0:000",
                    },
                    {
                      name: "secIdEnd",
                      value: "C-0:000",
                    },
                    {
                      name: "secIds",
                      value: "C-0:000",
                    },
                  ],
                  secIds: "C-0:000",
                },
              ],
            },
            checksum: "000d28bf_3",
          },

          selectedTariff: [
            {
              idLeg: 0,
              provider: "movitaxi",
              contextType: "BOOKEE_CONTEXT",
              price: {
                total: 1223,
                currency: "EUR",
                totalWithOutConcepts: 1223,
                concepts: [],
              },
              tickets: [
                {
                  context:
                    "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yNCIsImJ1ZGdldElkIjoiZjE5NjViOTYtOTAwNy00Zjc5LWExNDctYjU3MWNhNTlhNWQ4IiwicHJpY2UiOjEyLjIyNjA5OTk5OTk5OTk5OSwiY3VycmVuY3kiOiJFVVIifQ==",
                  idBook:
                    "bW92aXRheGl8aWR8MC4xfEl3dGhZS0FSMExERDI0T2c4M2duSEE9PXx7InVzZXJJZCI6IjQwY2U3NGExLTIxOTItNGMyZi1hZmY1LTBjMjNjYTc0NDZiNCIsInNlcnZpY2VJZCI6ImYxOTY1Yjk2LTkwMDctNGY3OS1hMTQ3LWI1NzFjYTU5YTVkOCJ9",
                  price: {
                    total: 1223,
                    currency: "EUR",
                    totalWithOutConcepts: 1223,
                    reservationAmount: 0,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "BOOKED",
                  extras: [],
                  ticketId: "c55e13e6-4083-4db9-88e8-b4cdbcb4dc2f",
                  docoTicketId: "e7b01d44-6d5f-2e0c-32bc-a721bdef605f",
                  offerId: "e40c6adc-4bcc-4a39-9ec0-8246331c3dc8#1",
                  offerIndex: 0,
                  referenceId: "2247848",
                },
              ],
              orderId: "O-000NNK",
              status: "BOOKED",
              notes: [
                {
                  type: "COMMENTS",
                  value:
                    "Test comentario conductor desde Android el 6 marzo 2026",
                },
              ],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentDataUid: "fcdf4f13-8d81-4651-ab45-0ed7fd01805d",
                paymentMethod: "CREDIT_CARD",
                paymentProcessId: "bced836e-e20a-4eda-b031-caf529d4cac6",
                paymentStatus: "CONFIRMED",
                digits: "541008******1539",
                expiryDate: "2049-12-31",
                ccType: "MASTERCARD",
              },
            },
            {
              idLeg: 1,
              provider: "movitaxi",
              contextType: "BOOKEE_CONTEXT",
              price: {
                total: 1223,
                currency: "EUR",
                totalWithOutConcepts: 1223,
                concepts: [],
              },
              tickets: [
                {
                  context:
                    "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yNCIsImJ1ZGdldElkIjoiZjE5NjViOTYtOTAwNy00Zjc5LWExNDctYjU3MWNhNTlhNWQ4IiwicHJpY2UiOjEyLjIyNjA5OTk5OTk5OTk5OSwiY3VycmVuY3kiOiJFVVIifQ==",
                  idBook:
                    "bW92aXRheGl8aWR8MC4xfEl3dGhZS0FSMExERDI0T2c4M2duSEE9PXx7InVzZXJJZCI6IjQwY2U3NGExLTIxOTItNGMyZi1hZmY1LTBjMjNjYTc0NDZiNCIsInNlcnZpY2VJZCI6ImYxOTY1Yjk2LTkwMDctNGY3OS1hMTQ3LWI1NzFjYTU5YTVkOCJ9",
                  price: {
                    total: 1223,
                    currency: "EUR",
                    totalWithOutConcepts: 1223,
                    reservationAmount: 0,
                    estimatedPrice: 0,
                    concepts: [],
                  },
                  status: "BOOKED",
                  extras: [],
                  ticketId: "c55e13e6-4083-4db9-88e8-b4cdbcb4dc2f",
                  docoTicketId: "e7b01d44-6d5f-2e0c-32bc-a721bdef605f",
                  offerId: "e40c6adc-4bcc-4a39-9ec0-8246331c3dc8#1",
                  offerIndex: 0,
                  referenceId: "2247848",
                },
              ],
              orderId: "O-000NNK",
              status: "BOOKED",
              notes: [
                {
                  type: "COMMENTS",
                  value:
                    "Test comentario conductor desde Android el 6 marzo 2026",
                },
              ],
              paymentInfo: {
                paymentProvider: "REDSYS",
                paymentDataUid: "fcdf4f13-8d81-4651-ab45-0ed7fd01805d",
                paymentMethod: "CREDIT_CARD",
                paymentProcessId: "bced836e-e20a-4eda-b031-caf529d4cac6",
                paymentStatus: "CONFIRMED",
                digits: "541008******1539",
                expiryDate: "2049-12-31",
                ccType: "MASTERCARD",
              },
            },
          ],
          originDate: "2026-03-06T10:09:00+01:00",
          destinationDate: "2026-03-06T10:13:00+01:00",
          completed: false,
          inProgress: false,
          price: {
            total: 1223,
            currency: "EUR",
            totalWithOutConcepts: 1223,
            concepts: [],
          },
        },
        price: {
          total: 0,
          totalWithOutConcepts: 0,
          concepts: [],
        },
      },
    ],
  },

  status: 200,
};
